import React from 'react';
import { XIcon, FilterIcon } from 'lucide-react';
import { categories } from '../../data/categories';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
interface ProductFiltersProps {
  selectedCategory: string;
  selectedBrand: string;
  priceRange: [number, number];
  onCategoryChange: (category: string) => void;
  onBrandChange: (brand: string) => void;
  onPriceRangeChange: (range: [number, number]) => void;
  onClearFilters: () => void;
  isMobile?: boolean;
  onClose?: () => void;
}
const brands = ['Apple', 'Samsung', 'Xiaomi', 'Anker', 'JBL', 'Logitech', 'Razer', 'Baseus', 'Amazfit', 'Keychron'];
export function ProductFilters({
  selectedCategory,
  selectedBrand,
  priceRange,
  onCategoryChange,
  onBrandChange,
  onPriceRangeChange,
  onClearFilters,
  isMobile = false,
  onClose
}: ProductFiltersProps) {
  const hasActiveFilters = selectedCategory || selectedBrand || priceRange[0] > 0 || priceRange[1] < 200000;
  const content = <div className="space-y-6" data-id="element-742">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-743">
        <div className="flex items-center gap-2" data-id="element-744">
          <FilterIcon className="w-5 h-5 text-gray-600" data-id="element-745" />
          <h3 className="font-semibold text-gray-900" data-id="element-746">Filters</h3>
        </div>
        {hasActiveFilters && <button onClick={onClearFilters} className="text-sm text-primary-600 hover:text-primary-700 font-medium" data-id="element-747">
            Clear all
          </button>}
      </div>

      {/* Categories */}
      <div data-id="element-748">
        <h4 className="font-medium text-gray-900 mb-3" data-id="element-749">Categories</h4>
        <div className="space-y-2" data-id="element-750">
          <label className="flex items-center gap-2 cursor-pointer" data-id="element-751">
            <input type="radio" name="category" checked={!selectedCategory} onChange={() => onCategoryChange('')} className="w-4 h-4 text-primary-600 focus:ring-primary-500" data-id="element-752" />
            <span className="text-sm text-gray-700" data-id="element-753">All Categories</span>
          </label>
          {categories.map(category => <label key={category.id} className="flex items-center gap-2 cursor-pointer" data-id="element-754">
              <input type="radio" name="category" checked={selectedCategory === category.slug} onChange={() => onCategoryChange(category.slug)} className="w-4 h-4 text-primary-600 focus:ring-primary-500" data-id="element-755" />
              <span className="text-sm text-gray-700" data-id="element-756">{category.name}</span>
              <span className="text-xs text-gray-400 ml-auto" data-id="element-757">
                ({category.productCount})
              </span>
            </label>)}
        </div>
      </div>

      {/* Brands */}
      <div data-id="element-758">
        <h4 className="font-medium text-gray-900 mb-3" data-id="element-759">Brands</h4>
        <div className="space-y-2 max-h-48 overflow-y-auto" data-id="element-760">
          <label className="flex items-center gap-2 cursor-pointer" data-id="element-761">
            <input type="radio" name="brand" checked={!selectedBrand} onChange={() => onBrandChange('')} className="w-4 h-4 text-primary-600 focus:ring-primary-500" data-id="element-762" />
            <span className="text-sm text-gray-700" data-id="element-763">All Brands</span>
          </label>
          {brands.map(brand => <label key={brand} className="flex items-center gap-2 cursor-pointer" data-id="element-764">
              <input type="radio" name="brand" checked={selectedBrand === brand} onChange={() => onBrandChange(brand)} className="w-4 h-4 text-primary-600 focus:ring-primary-500" data-id="element-765" />
              <span className="text-sm text-gray-700" data-id="element-766">{brand}</span>
            </label>)}
        </div>
      </div>

      {/* Price Range */}
      <div data-id="element-767">
        <h4 className="font-medium text-gray-900 mb-3" data-id="element-768">Price Range</h4>
        <div className="flex items-center gap-2" data-id="element-769">
          <Input type="number" placeholder="Min" value={priceRange[0] || ''} onChange={e => onPriceRangeChange([Number(e.target.value) || 0, priceRange[1]])} className="text-sm" data-id="element-770" />
          <span className="text-gray-400" data-id="element-771">-</span>
          <Input type="number" placeholder="Max" value={priceRange[1] === 200000 ? '' : priceRange[1]} onChange={e => onPriceRangeChange([priceRange[0], Number(e.target.value) || 200000])} className="text-sm" data-id="element-772" />
        </div>
        <div className="flex flex-wrap gap-2 mt-3" data-id="element-773">
          <button onClick={() => onPriceRangeChange([0, 5000])} className="px-3 py-1 text-xs rounded-full border border-gray-200 hover:border-primary-500 hover:text-primary-600 transition-colors" data-id="element-774">
            Under PKR 5K
          </button>
          <button onClick={() => onPriceRangeChange([5000, 20000])} className="px-3 py-1 text-xs rounded-full border border-gray-200 hover:border-primary-500 hover:text-primary-600 transition-colors" data-id="element-775">
            PKR 5K - 20K
          </button>
          <button onClick={() => onPriceRangeChange([20000, 50000])} className="px-3 py-1 text-xs rounded-full border border-gray-200 hover:border-primary-500 hover:text-primary-600 transition-colors" data-id="element-776">
            PKR 20K - 50K
          </button>
          <button onClick={() => onPriceRangeChange([50000, 200000])} className="px-3 py-1 text-xs rounded-full border border-gray-200 hover:border-primary-500 hover:text-primary-600 transition-colors" data-id="element-777">
            Above PKR 50K
          </button>
        </div>
      </div>

      {/* Mobile apply button */}
      {isMobile && onClose && <div className="pt-4 border-t border-gray-200" data-id="element-778">
          <Button variant="primary" fullWidth onClick={onClose} data-id="element-779">
            Apply Filters
          </Button>
        </div>}
    </div>;
  if (isMobile) {
    return <div className="fixed inset-0 z-50 bg-white overflow-y-auto" data-id="element-780">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between" data-id="element-781">
          <h2 className="font-semibold text-gray-900" data-id="element-782">Filters</h2>
          <button onClick={onClose} className="p-2 text-gray-500 hover:text-gray-700" data-id="element-783">
            <XIcon className="w-5 h-5" data-id="element-784" />
          </button>
        </div>
        <div className="p-4" data-id="element-785">{content}</div>
      </div>;
  }
  return <div className="bg-white rounded-xl border border-gray-100 shadow-card p-5" data-id="element-786">
      {content}
    </div>;
}